import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './index';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: localStorage.getItem('language') ?? navigator.language.split('-')[0],
  fallbackLocale: 'en',
  messages,
});
